module.exports = {"id":"178319","name":"Wout Brama","rating":"72","photo":"./data/images/photos/4/178319.png","club":{"name":"Central Coast","logo":"./data/images/clubs/CentralCoast.png"},"positions":["MDC"],"photoFolderIndex":4}


//////////////////
// WEBPACK FOOTER
// ./src/data/players/WoutBrama0.json
// module id = 4362
// module chunks = 0